export default "__VITE_ASSET__jHyDYRTl__"